export default __webpack_public_path__ + "static/media/menu.e21bab1d.svg";